module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/id/2-2caf0567a6bd94dba5069a913d37b6ac.jpg";